<script>
import { toRef, watchEffect } from "vue";
import { useStore } from "vuex";
import { useLog } from "../../../../../../services/hooks";
import { normalizeDateFormat } from "../../../../../../helpers/dateHelper";
import NavigationComponent from "./NavigationComponent.vue";
import { cleanName } from "@/services/helpers";

export default {
  name: 'ClientNameComponent',
  components: {
    NavigationComponent
  },
  props: {
    clientName: {
      type: Object,
      required: true
    },
    createPreOrderSubmitHandler: {
      type: Function,
      required: true
    },
    prevStepHandler: {
      type: Function,
      required: true
    }
  },
  setup(props) {

    const store = useStore();
    const clientName = toRef(props, 'clientName');
    const { recordLog } = useLog();

      const normalizeDateFormatHandler = (e) => {
          e.target.value = normalizeDateFormat(e.target.value);
      };

      const validateForm = () => {

        let hasError = false;

        if(clientName.value.value === '') {
          clientName.value.hasError = true;
          clientName.value.errorText = 'Поле обязательно к заполнению';
          hasError = true;
        } else {
          clientName.value.hasError = false;
          clientName.value.errorText = '';
        }

        return !hasError;
      };

    const onKeyUp = () => {
      props.clientName.value = cleanName(props.clientName.value);
    }

      watchEffect(() => {
        if(store.state.auth.user) {
          recordLog('Переход к заполнению данных о заказчике');
        }
      });

      return {
        validateForm,
        normalizeDateFormatHandler,
        onKeyUp
      }
  }
}
</script>

<template>
  <div class="step-3">
    <div class="cart-form">
      <form @submit="createPreOrderSubmitHandler">
        <h1>Данные заказчика оценки</h1>
        <div class="group-block">
          <span class="group-block-title">ФИО заказчика</span>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <dadata-suggestions
                  v-model="clientName.value"
                  type="NAME"
                  @keyup="onKeyUp"
                  @change="validateForm()"
                  @focusout="validateForm()"
                  class="form-control"
                />
                <p class="error" v-if="clientName.hasError">{{ clientName.errorText }}</p>
              </div>
            </div>
          </div>
        </div>
        <navigation-component
          :prev-step-handler="prevStepHandler"
          :validate-form="validateForm"
        />
      </form>
    </div>
  </div>
</template>

<style scoped>

  .step-3 {
    max-width: 600px;
    margin: 0 auto;
  }

  .mx-datepicker {
    width: 100%;
  }

  label {
    display: block;
    position: relative;
  }

  .form-group {
    margin-bottom: 0;
    position: relative;
  }

  .row {
    margin-bottom: 15px;
  }

  .row:last-child {
    margin-bottom: 0;
  }

  .group-block {
    border: 1px solid #c7c7c7;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 15px;
    position: relative;
  }

  .group-block-title {
    position: absolute;
    top: -8px;
    left: 10px;
    background-color: #efefef;
    font-size: 10px;
    text-transform: uppercase;
    display: inline-block;
    padding: 2px;
    color: #000000;
  }

  .label-prompt {
    position: relative;
  }

  .label-prompt>span {
    position: absolute;
    top: 0;
    left: 15px;
    border: 1px solid gray;
    padding: 5px;
    border-radius: 5px;
    background-color: #FFFFFF;
    font-weight: normal;
    font-size: 11px;
    max-width: 300px;
    width: max-content;
    width: -moz-max-content;
    z-index: 2;
    display: none;
  }

  .label-prompt:hover>span {
    display: block;
  }

  label .prompt-text {
    font-size: 12px;
    font-weight: normal;
    color: #606060;
  }

  .suggestions-wrapper {
    position: absolute;
    width: 100%;
    z-index: 2;
  }

</style>
